export default "__VITE_ASSET__DiRO8GNC__"